import crypto from 'crypto-js';

const HMAC_KEY = process.env.REACT_APP_HMAC_HASH_KEY;
export function hashField(value) {
    if(typeof value !== 'string') {
        console.log('Invalid memberId/memberName');
        return null
    };
    const cleaned = value.toLowerCase().trim();
    return crypto.HmacSHA256(cleaned, HMAC_KEY).toString(crypto.enc.Hex);
  }